import { actionGenerator, IReduxAction } from '../../utils/actions';
import { ETopBetsErrorCode } from '../../types/reducers/topBets';

export const LOAD_TOP_BETS_FAIL = 'TOP_BETS :: LOAD_TOP_BETS_FAIL';

export type TLoadTopBetsFailAction = IReduxAction<typeof LOAD_TOP_BETS_FAIL, ETopBetsErrorCode>;

export const loadTopBetsFail = actionGenerator<typeof LOAD_TOP_BETS_FAIL, ETopBetsErrorCode>(LOAD_TOP_BETS_FAIL);
